import React from "react";
import styled from "styled-components";
import Helmet from "react-helmet";

const Wrapper = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: column-reverse;
  margin: 0 auto 17px;
  max-width: 900px;
  padding: 0 20px;
`;

const Copyright = styled.span`
  color: #ffffff;
  font-size: 1.125rem;
  line-height: 1.6875;
  margin: 0;
  opacity: 0.5;
  padding: 0;
`;

const EmailLink = styled.a`
  color: #ffffff;
  font-size: 1.125rem;
  line-height: 1.6875;
  margin: 0 0 13px;
  outline: none;
  padding: 0;
  text-decoration: none;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #03feb2;
  }
`;

const Footer = () => (
  <div>
    <Helmet title="Blast - Forgot Password" />
    <Wrapper>
      <Copyright>&copy; Blast</Copyright>

      <EmailLink
        href="mailto:support@blast.com?subject=Password Reset Help"
        target="_blank"
      >
        support@blast.com
      </EmailLink>
    </Wrapper>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx